import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, ArrowRight } from 'lucide-react';
export function ClosingSection() {
  return <section id="contact" className="py-24 md:py-32 bg-blue-600 relative overflow-hidden" data-id="element-13">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/pv7y6xaDjdJjZw7MatuMW7/pcs_cierre.png)'
    }} data-id="element-14" />
      <div className="absolute inset-0 bg-blue-600/75" data-id="element-15" />
      <div className="absolute inset-0 bg-gradient-to-t from-blue-900/50 to-transparent" data-id="element-16" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center" data-id="element-17">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-display text-4xl md:text-6xl font-bold text-white mb-8 leading-tight" data-id="element-18">
          Your Competition Is Already Investing in Their Digital Authority.
          <br data-id="element-19" />
          <span className="text-blue-200" data-id="element-20">The Question Is: Are You?</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-black/20 backdrop-blur-sm border border-white/20 p-8 rounded-sm max-w-3xl mx-auto mb-12 flex flex-col md:flex-row items-center gap-6 text-left" data-id="element-21">
          <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center shrink-0" data-id="element-22">
            <ShieldCheck size={32} className="text-white" data-id="element-23" />
          </div>
          <div data-id="element-24">
            <h3 className="font-display text-xl font-bold text-white mb-2" data-id="element-25">
              90-Day Performance Guarantee
            </h3>
            <p className="text-blue-100 text-sm leading-relaxed" data-id="element-26">
              If your new digital presence doesn't outperform your current one
              in speed, engagement, and conversions within 90 days, we rebuild
              it — free. We stake our reputation on your results.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-27">
          <a href="https://wa.link/dis8bj" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto group flex items-center justify-center gap-2 bg-white text-blue-600 px-10 py-5 rounded-sm font-bold text-lg hover:bg-neutral-100 transition-all shadow-xl" data-id="element-28">
            Book Your Private Strategy Call
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" data-id="element-29" />
          </a>
          <a href="#contact" className="w-full sm:w-auto flex items-center justify-center bg-transparent border border-white/30 hover:border-white hover:bg-white/10 text-white px-8 py-5 rounded-sm font-medium transition-all" data-id="element-30">
            Get a Free Digital Audit
          </a>
        </motion.div>
      </div>
    </section>;
}